/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { remap as remap$ } from "../../lib/primitives.js";
import { safeParse } from "../../lib/schemas.js";
import * as openEnums from "../../types/enums.js";
import { OpenEnum } from "../../types/enums.js";
import { Result as SafeParseResult } from "../../types/fp.js";
import { SDKValidationError } from "../errors/sdkvalidationerror.js";
import {
  OpenAPIv3AffectedToolset,
  OpenAPIv3AffectedToolset$inboundSchema,
} from "./openapiv3affectedtoolset.js";
import {
  OpenAPIv3DocumentSnapshot,
  OpenAPIv3DocumentSnapshot$inboundSchema,
} from "./openapiv3documentsnapshot.js";
import {
  OpenAPIv3EvaluationChange,
  OpenAPIv3EvaluationChange$inboundSchema,
} from "./openapiv3evaluationchange.js";

/**
 * Whether the source is new, changed, unchanged or removed.
 */
export const OpenAPIv3EvaluationStatus = {
  New: "new",
  Changed: "changed",
  Unchanged: "unchanged",
  Removed: "removed",
} as const;
/**
 * Whether the source is new, changed, unchanged or removed.
 */
export type OpenAPIv3EvaluationStatus = OpenEnum<
  typeof OpenAPIv3EvaluationStatus
>;

/**
 * The changes an OpenAPI document introduces compared with the deployed version of the same source.
 */
export type OpenAPIv3Evaluation = {
  /**
   * Toolsets (MCP servers) that include tools from this source.
   */
  affectedToolsets: Array<OpenAPIv3AffectedToolset>;
  /**
   * The asset ID of the evaluated document. Absent when the source was removed.
   */
  assetId?: string | undefined;
  base?: OpenAPIv3DocumentSnapshot | undefined;
  /**
   * The asset ID of the deployed document. Absent for a new source.
   */
  baseAssetId?: string | undefined;
  /**
   * The number of breaking changes.
   */
  breakingCount: number;
  /**
   * Every change found, most severe first.
   */
  changes: Array<OpenAPIv3EvaluationChange>;
  /**
   * The number of informational changes.
   */
  infoCount: number;
  /**
   * The display name of the OpenAPI source.
   */
  name: string;
  next?: OpenAPIv3DocumentSnapshot | undefined;
  /**
   * The slug of the OpenAPI source.
   */
  slug: string;
  /**
   * Whether the source is new, changed, unchanged or removed.
   */
  status: OpenAPIv3EvaluationStatus;
  /**
   * The number of changes that need attention.
   */
  warningCount: number;
};

/** @internal */
export const OpenAPIv3EvaluationStatus$inboundSchema: z.ZodMiniType<
  OpenAPIv3EvaluationStatus,
  unknown
> = openEnums.inboundSchema(OpenAPIv3EvaluationStatus);

/** @internal */
export const OpenAPIv3Evaluation$inboundSchema: z.ZodMiniType<
  OpenAPIv3Evaluation,
  unknown
> = z.pipe(
  z.object({
    affected_toolsets: z.array(OpenAPIv3AffectedToolset$inboundSchema),
    asset_id: z.optional(z.string()),
    base: z.optional(OpenAPIv3DocumentSnapshot$inboundSchema),
    base_asset_id: z.optional(z.string()),
    breaking_count: z.int(),
    changes: z.array(OpenAPIv3EvaluationChange$inboundSchema),
    info_count: z.int(),
    name: z.string(),
    next: z.optional(OpenAPIv3DocumentSnapshot$inboundSchema),
    slug: z.string(),
    status: OpenAPIv3EvaluationStatus$inboundSchema,
    warning_count: z.int(),
  }),
  z.transform((v) => {
    return remap$(v, {
      "affected_toolsets": "affectedToolsets",
      "asset_id": "assetId",
      "base_asset_id": "baseAssetId",
      "breaking_count": "breakingCount",
      "info_count": "infoCount",
      "warning_count": "warningCount",
    });
  }),
);

export function openAPIv3EvaluationFromJSON(
  jsonString: string,
): SafeParseResult<OpenAPIv3Evaluation, SDKValidationError> {
  return safeParse(
    jsonString,
    (x) => OpenAPIv3Evaluation$inboundSchema.parse(JSON.parse(x)),
    `Failed to parse 'OpenAPIv3Evaluation' from JSON`,
  );
}
